/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { BodyCancel, ControlApi, ResultTaskList } from "client";
import { useState } from "react";
import { useApiWithTimeout } from "hooks/ApiWrapperWithTimeout";
import { useCallApi } from "hooks/CallApiHook";
import { Const } from "const";

export const useCancelTask = () => {
  const [controlApi, cancelControlApi] = useApiWithTimeout(
    ControlApi,
    Const.operationTimeout.cancelTask
  );
  const [targetTask, setTargetTask] = useState<ResultTaskList>();
  const result = useCallApi(
    async () => {
      if (targetTask) {
        const bodyCancel: BodyCancel = {
          frameTypeAndNumber: targetTask.frameTypeAndNumber!,
          taskId: targetTask.taskId!,
        };
        await controlApi.cancelTask({
          bodyCancel,
        });
      }
      return targetTask;
    },
    cancelControlApi,
    [cancelControlApi, controlApi, targetTask]
  );
  return { ...result, setTargetTask };
};
